import { Add } from "@mui/icons-material";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { PlanWeek } from "@readyfit-common/models";
import { useAppDispatch } from "src/store/hooks";
import {
  setSelectedDate,
  setSelectedDayNumber,
  setSelectedWeek,
  setSelectedWorkout,
  setWorkoutModalOpen,
} from "src/store/reducers/training/trainingApiSlice";
import useStyles from "./EmptyDayCard.styles";

interface EmptyDayCardProps {
  dayOfTheWeek: string;
  date: string;
  isToday: boolean;
  isEditable?: boolean;
  week: PlanWeek;
  isTemplate?: boolean;
  index: number;
}

const EmptyDayCard = ({
  dayOfTheWeek,
  date,
  isToday,
  isEditable,
  week,
  isTemplate,
  index,
}: EmptyDayCardProps) => {
  const css = useStyles({ isToday: isToday || false })();
  const dispatch = useAppDispatch();

  const handleOpenAddWorkoutModal = () => {
    dispatch(setWorkoutModalOpen(true));
    dispatch(setSelectedWeek(week));
    dispatch(setSelectedWorkout(null));
    dispatch(setSelectedDayNumber(index + 1));

    // If it's not a template, set the date
    if (!isTemplate) {
      dispatch(setSelectedDate(new Date(date).toISOString()));
    }
  };

  return (
    <Grid container className={css.header}>
      <Grid container>
        <Grid item xs={10} className={css.day}>
          <Typography
            variant="subtitle1"
            color={isToday ? "#fff" : "#000"}
            fontWeight={"bold"}
          >
            {dayOfTheWeek?.toUpperCase()}
          </Typography>
          {!isTemplate && (
            <Typography
              variant="caption"
              color={isToday ? "#fff" : "#000"}
              fontWeight={"bold"}
            >
              {moment(date).format("DD")}
            </Typography>
          )}
        </Grid>
        {isEditable && (
          <Grid item xs={2}>
            <Tooltip title="Add">
              <IconButton onClick={handleOpenAddWorkoutModal}>
                <Add style={{ color: isToday ? "#fff" : "#000" }} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default EmptyDayCard;
